<template>
    <v-layout align-start>
        <v-flex>
             <v-data-table
                :headers="headers"
                :items="comunicados"
                :search="search"
                sort-by="calories"
                class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat color="white">
                <v-toolbar-title>Comunicados</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Busqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <!-- ********** -->
                <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on" outlined>Crear Comunicado</v-btn>
                    </template>
                    <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title><span class="headline">{{ formTitle }}</span></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="limpiar()">Limpiar Controles</v-btn>
                        </v-toolbar-items>
                        <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="crear">Grabar</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-list three-line subheader>
                        <!-- <v-subheader><strong> Seleccione Tipo de Comunicado</strong></v-subheader> -->
                        <v-container fluid>
                            <span>  Seleccione Tipo de Comunicado </span>
                            <v-row>
                                <v-col cols="12" sm="6" md="3">
                                <v-radio-group v-model="editedItem.idTIpoMensaje" row>
                                    <v-radio label="Texto" value="1"></v-radio>
                                    <v-radio label="Imagen" value="2"></v-radio>
                                    <v-radio label="PDF" value="3"></v-radio>
                                </v-radio-group>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Titulo"
                                        v-model="editedItem.titulo"
                                        outlined>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="12" v-if="editedItem.idTIpoMensaje == '1'">
                                    <v-textarea
                                        outlined
                                        name="Mensaje"
                                        label="Mensaje"
                                        v-model="editedItem.mensaje"
                                        value="">
                                    </v-textarea>
                                </v-col>
                                <v-col cols="12" md="12" v-if="editedItem.idTIpoMensaje == '2'">
                                    <v-file-input
                                        :rules="rulesIMG"
                                        show-size
                                        accept=".png, .jpeg, .bmp, .jpg"
                                        placeholder="Elige la imagen"
                                        prepend-icon="image"
                                        filled
                                        outlined
                                        @change="SubirArchivo"
                                        label="Imagen del comunicado">
                                    </v-file-input>
                                </v-col>
                                <v-col cols="12" md="12" v-if="editedItem.idTIpoMensaje == '3'">
                                    <vue-dropzone
                                        ref="dropzone"
                                        id="customdropzone"
                                        :options="dropzoneOptions"
                                        :duplicateCheck="true"
                                        :useCustomSlot=true
                                        @vdropzone-complete="oncomplete"
                                        
                                        @vdropzone-success="onsuccess"
                                        @vdropzone-success-multiple="onsuccess"
                                        @vdropzone-error="errorDropzone"
                                        @vdropzone-duplicate-file="duplicateFile"
                                        @vdropzone-total-upload-progress="tuploadprogress"
                                        @vdropzone-file-added="onadded"
                                        @vdropzone-files-added="onadded"
                                        >
                                        <div class="dropzone-custom-content">
                                            <h3 class="dropzone-custom-title">Arrastra y suelta para cargar contenido!</h3>
                                            <div class="subtitle">...o haga click para seleccionar un archivo de su computadora</div>
                                        </div>
                                    </vue-dropzone>
                                </v-col>
                                <v-col cols="12" lg="4">
                                    <v-menu
                                        ref="FechaIni"
                                        v-model="FechaIni"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="editedItem.fechaInicio"
                                                label="Fecha Inicio"
                                                prepend-icon="event"
                                                readonly
                                                v-on="on">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="editedItem.fechaInicio" no-title @input="FechaIni = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                        
                                <v-col cols="12" lg="4">
                                    <v-menu
                                        v-model="FechaFin"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="editedItem.fechaFin"
                                                label="Fecha Fin"
                                                prepend-icon="event"
                                                readonly
                                                v-on="on">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="editedItem.fechaFin" no-title @input="FechaFin = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-switch v-model="editedItem.vigencia" class="ma-2" label="Vigencia"></v-switch>
                            </v-row>
                        </v-container>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list three-line subheader>
                        </v-list>
                        </v-card>
                    </v-dialog>


                <!-- ********** -->
                </v-toolbar>
            </template>            
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="item in items" :key="item.name">
                        <td>
                            <div>
                                <v-icon small class="mr-2" @click="editItem(item)">
                                    edit
                                </v-icon>
                                <v-icon small @click="deleteItem(item)">
                                    delete
                                </v-icon>
                            </div>
                        </td>
                        <td>
                            <div v-if="item.sTipoMensaje === 'Texto'">
                                <v-icon @click="VerTipo(item)">
                                    textsms
                                </v-icon>
                            </div>
                            <div v-if="item.sTipoMensaje === 'Image' || item.sTipoMensaje === 'Imagen'">
                                <v-icon @click="VerTipo(item)">
                                    insert_photo
                                </v-icon>                                
                            </div>
                            <div v-if="item.sTipoMensaje === 'Pdf'">
                                <v-icon @click="VerTipo(item)">
                                    picture_as_pdf
                                </v-icon>
                            </div>
                        </td>
                        <td>{{ item.titulo }}</td>
                        <td>{{ item.fechaInicio }}</td>
                        <td>{{ item.fechaFin }}</td>
                        <td>
                            <div v-if="item.vigencia" @click="desactivaritem(item)">
                                <v-btn class="green--text" text >Activo</v-btn>
                            </div>
                            <div v-else @click="activaritem(item)">
                                <v-btn class="red--text" text >Inactivo</v-btn>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </template> 
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Resetear</v-btn>
            </template>
            </v-data-table>

            <v-dialog v-model="vDialogTipo" fullscreen 
                hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="vDialogTipo = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{vShowTipo.sTipoMensaje}}</v-toolbar-title>
                        <v-spacer></v-spacer>            
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-list-item>
                        <v-list-item-content v-show="vShowTipo.sTipoMensaje === 'Texto'">
                            <v-list-item-title>{{vShowTipo.titulo}}</v-list-item-title>
                            <v-list-item-subtitle>{{vShowTipo.mensaje}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-show="vShowTipo.sTipoMensaje === 'Image' || vShowTipo.sTipoMensaje === 'Imagen'">
                            <v-list-item-title>{{vShowTipo.titulo}}</v-list-item-title>
                            <v-list-item-subtitle>
                                <iframe id="iframe1" runat="server" :src="vShowTipo.path" style="width:100%;height:700px;"></iframe>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-show="vShowTipo.sTipoMensaje === 'Pdf'">
                            <v-list-item-title>{{vShowTipo.titulo}}</v-list-item-title>
                            <v-list-item-subtitle>
                              <blockquote class="quote"><div class="op">Quote:</div>
                                <iframe id="iframe1" runat="server" :src="vShowTipo.path" style="width:100%;height:700px;"></iframe>
                              </blockquote>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        </v-list-item>            
                    </v-list>                    
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>  

<script>
// import axios from 'axios'
// import moment from 'moment'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            comunicados:[],
            dialog: false,
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },
                { text: 'Tipo Mensaje', value: 'sTipoMensaje' },
                { text: 'Titulo', value: 'titulo' },
                { text: 'Fecha Inicio', value: 'fechaInicio' },
                { text: 'Fecha Fin', value: 'fechaFin' },
                { text: 'Vigencia', value: 'vigencia' },
            ],
            rulesIMG: [
                value => !value || value.size < 2000000 || 'La imagen no puede ser mayor de 2 MB!',
            ],
            rulesPDF: [
                value => !value || value.size < 2000000 || 'El PDF no puede ser mayor de 2 MB!',
            ],
            vDialogTipo: false,
            vShowTipo: 'Texto',
            files: null,
            search: '',
            timeout: 6000,
            textoAct: '',
            snackbar: false,
            snackbarcolor: '',
            FechaIni: false,
            FechaFin: false,
            editedIndex: -1,
            editedItem: {
                idTIpoMensaje: '1',
                titulo: '',
                mensaje: '',
                path:'',
                fechaInicio: new Date().toISOString().substr(0, 10),
                fechaFin: new Date().toISOString().substr(0, 10),
                vigencia:1
            },
            //date: new Date().toISOString().substr(0, 10),
            //dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
           /*  defaultItem: {
                name: '',
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0,
            }, */
            idTIpoMensaje: '1',
            titulo: '',
            mensaje: '',
            path:' ',
            fechaInicio: new Date().toISOString().substr(0, 10),
            fechaFin: new Date().toISOString().substr(0, 10),
            vigencia:1,
            dropzoneOptions: {
                url: '',
                thumbnailWidth: 200,
                maxFilesize: 5,
                addRemoveLinks: true,
                headers: { "My-Awesome-Header": "header value" }
            } 

        }
    },
    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'Crear Comunicado' : 'Actualizar Comunicado'
        },
    },

    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar()
    },
    mounted () {
        this.dropzoneOptions.url = this.$uriApi + 'Comunicados/SubirArchivo/'
        console.log(this.dropzoneOptions.url)
    },
    methods: {
        listar () {
            let me = this
            me.$axios.get('api/comunicados/listar')
                .then(response => {
                    var tempCat = response.data
                    for (var i = 0; i < tempCat.length; i++) {
                        var item = tempCat[i]
                        item.path = me.SetPath(item.path)
                        me.comunicados.push(item)
                    }
                    console.log(me.comunicados)
                }).catch(error => {
                    console.log(error)
                })
        },
        desactivaritem (item) {
            let me=this;      
            debugger  
         
            this.$axios.get('api/comunicados/desactivar?Id='+item.idMensaje).then(function(response){
                item.vigencia = false;
                me.textoAct = "Se desactivo con éxito";
                me.snackbar = true;
                me.snackbarcolor = 'red';
            }).catch(function(error){
                    console.log(console.error());
            });
        },
        activaritem (item) {
            let me=this;    
            debugger    
            this.$axios.get('api/comunicados/activar?Id='+item.idMensaje)
                .then(function(response) {
                    item.vigencia = true;
                    me.textoAct = "Se Activo con éxito";
                    me.snackbar = true;
                    me.snackbarcolor = 'teal darken-4';
                }).catch(function(error){
                        console.log(console.error());
                })
        },
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        deleteItem (item) {

            debugger
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/comunicados/Delete?Id=' + item.idMensaje)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Registro eliminado')
                        me.comunicados = [];
                        me.listar()
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => {                     
                    this.$root.Mensaje(e)
                })
        },
        limpiar () {
            this.editedItem.idTIpoMensaje = '1'
            this.editedItem.titulo = ''
            this.editedItem.mensaje = ''
            this.editedItem.path = ''
            this.editedItem.fechaInicio = new Date().toISOString().substr(0, 10)
            this.editedItem.fechaFin =  new Date().toISOString().substr(0, 10)
            this.editedItem.vigencia = 1
        },
        editItem (item) {
            this.editedItem = item
            this.dialog = true
            console.log(this.editedItem)
        },
        crear (item) {
            let me = this
            if (me.editedItem.idTIpoMensaje != 1 ) {
                //me.SubirArchivo();
            }
            if (me.editedItem > -1) {
                Object.assign(this.desserts[this.editedIndex], this.editedItem)
            }
            else {                
                var vigencia = me.editedItem.vigencia == 1 ? true : false
                var tipo = me.editedItem.idTIpoMensaje == 1 ? 1 : me.editedItem.idTIpoMensaje == 2 ? 2: 3
                var json = { 
                    "IdMensaje": me.editedItem.idMensaje,
                    "IdTIpoMensaje": tipo,
                    "Titulo": me.editedItem.titulo,
                    "Mensaje": me.editedItem.mensaje,
                    "Path": me.editedItem.path,
                    "FechaInicio": me.$moment(me.editedItem.fechaInicio).format("YYYY-MM-DD"),
                    "FechaFin": me.$moment(me.editedItem.fechaFin).format("YYYY-MM-DD"),
                    "Vigencia": vigencia,
                    "Sustituir": !vigencia
                }
                // debugger
                me.$axios.post('api/comunicados/crear', json)
                    .then(response => {
                        me.comunicados = [];
                        me.listar()
                        if (response.data.exito) {
                            me.limpiar()
                            item.vigencia = true
                            me.textoAct = "Se Activo con éxito"
                            me.close()
                        }
                        else {
                            me.textoAct = response.data.mensaje
                        }
                        me.$root.Mensaje(response.data.mensaje, 'primary')
                    })
                    .catch (error => {
                        me.$root.Mensaje(response.data.mensaje)
                        me.close()
                    })
            }
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
               this.editedItem = Object.assign({}, this.defaultItem) 
               this.editedIndex = -1;
            }, 300);
        },
        SubirArchivo (e) {
            // debugger
            let me = this
            let formData = new FormData()
            if (e === undefined || e === null) {
                for (var i = 0; i < me.files.length; i++) {
                    let file = me.files[i]
                    formData.append('files[' + i + ']', file)
                }
            }
            else {
                formData.append('files[0]', e)
            }
            me.$axios.post('api/Comunicados/SubirArchivo',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(s => {
                    console.log(s)
                    if(s.data.exito){
                        me.editedItem.path = s.data.mensaje
                        console.log(me.editedItem.path)
                    }
                    console.log('Correcto!')
                })
                .catch(e => {
                    console.log(e)
                })
        },
        onFileChange (fieldName, file) {
            const { maxSize } = this
            let imageFile = file[0]
            if (file.length>0) {
            let size = imageFile.size / maxSize / maxSize
                if (!imageFile.type.match('image.*')) {
                    // check whether the upload is an image
                    this.errorDialog = true
                    this.errorText = 'Please choose an image file'
                } else if (size>1) {
                    // check whether the size is greater than the size limit
                    this.errorDialog = true
                    this.errorText = 'Your file is too big! Please select an image under 1MB'
                } else {
                    // Append file into FormData and turn file into image URL
                    debugger; 
                    let formData = new FormData()
                    let imageURL = URL.createObjectURL(imageFile)
                    formData.append(fieldName, imageFile)
                    // Emit the FormData and image URL to the parent component
                    this.$emit('input', { formData, imageURL })
                }
            }  
        }, 
        onsuccess (e, r) {
            //debugger
            // console.log(e)
            
            if (r.exito) {
                this.success = true
                this.editedItem.path = r.mensaje
                console.log(this.editedItem.path)
            }
        },
        onadded(file) {},
        oncomplete (file) { },
        tuploadprogress (totaluploadprogress, totalBytes, totalBytesSent) {},
        errorDropzone (file) {},
        duplicateFile (e) {},
        VerTipo (comunicado) {
            // this.vShowTipo = comunicado
            //this.vDialogTipo = true
            window.open(
              comunicado.path,
              '_blank'
            );
        },
        SetPath (urlServer) {
            var url = ''
            var cadena = urlServer
            var u1 = this.$uriApImg
            //'http://apicontigo.cosmic.mx/FileMessage'
            if (cadena === undefined || cadena === '' || cadena === null)
                return ''

            var arr = cadena.split('FileMessage')
            if (arr.length > 0) {
                url = u1 + arr[1]
                // console.log(url)
            }
            return url
        }
    }
}
</script>
